function getPreviewId(baseHost: string): string | null {
  const current = window.location.hostname
  if (current === baseHost || !current.endsWith(`.${baseHost}`)) {
    return null
  }
  return current.slice(0, -(baseHost.length + 1))
}

export function buildPreviewUrl(
  baseUrl: string,
  baseHost: string | undefined,
): string {
  if (baseHost == null || baseHost === '') {
    return baseUrl
  }
  const previewId = getPreviewId(baseHost)
  if (previewId == null || previewId === '') {
    return baseUrl
  }
  const url = new URL(baseUrl)
  url.hostname = `${previewId}.${url.hostname}`
  return url.toString().replace(/\/$/, '')
}
